import React from 'react';
import { ChevronRightFilled } from '@/components/Icons/ChevronRightFilled';
import type { LinkResponse } from '@/types/links';

interface Props {
  link: LinkResponse;
  onOpen: (link: LinkResponse) => void;
}

export const ExternalLinkCard: React.FC<Props> = ({ link, onOpen }) => (
  <button
    type="button"
    className="flex h-16 w-full cursor-pointer items-center justify-between gap-3 rounded-xl bg-card px-4 text-left shadow-card transition-colors hover:bg-hover active:bg-background md:h-[72px] md:rounded-[20px] md:pr-4 md:pl-6"
    onClick={() => onOpen(link)}
  >
    <span className="text-subhead-14 text-primary md:text-callout-16">
      {link.name}
    </span>
    <ChevronRightFilled className="size-4 shrink-0 text-muted-foreground" />
  </button>
);
